// admin
import { clientManagement } from '../../../admin/locales/en/clientManagement'
import { signUpClient } from '../../../admin/locales/en/signUpClient'

// analysis
import { consultingAnalysis } from '../../../analysis/locales/en/consultingAnalysis'

// v2
import { register } from './register'
import { verify } from './verify'
import { common } from './common'
import { home } from './home'
import { companyProfile } from './companyProfile'
import { cluster } from './cluster'
import { clusterTable } from './clusterTable'
import { clusterDetailTable } from './clusterDetailTable'
import { ipcTableOfClusterDetail } from './ipcTableOfClusterDetail'
import { companyTableOfClusterDetail } from './companyTableOfClusterDetail'
import { patentTableOfClusterDetail } from './patentTableOfClusterDetail'
import { modalOfIpcTable } from './modalOfIpcTable'
import { patentByYearChart } from './patentByYearChart'
import { confirmationModalOfClusterValueChain } from './confirmationModalOfClusterValueChain'
import { wordCloud } from './wordCloud'
import { valueChain } from './valueChain'
import { network } from './network'
import { chaosMap } from './chaosMap'
import { allServiceStop } from './allServiceStop'
import { systemInfoManagement } from './systemInfoManagement'
import { simulation } from './simulation'
import { loginiam } from './loginiam'
import { theme } from './theme'
import { chooseCmp } from './chooseCmp'
import { themePage } from './themePage'
import { themePageCompanyAnaly } from './themePageCompanyAnaly'
import { themePageCountryAnaly } from './themePageCountryAnaly'
import { aboutTheService } from './aboutTheService'
import { supportHeader } from './supportHeader'
import { supportLink } from './supportLink'
import { howToUseModal } from './howToUseModal'
import { glossary } from './glossary'
import { howToUse, newBusiness, strategyDevelopment } from './howToUse'
import { tooltip } from './tooltip'
import { allCompanyPortfolio } from './allCompanyPortfolio'
import { allCountryPortfolio } from './allCountryPortfolio'
import { byCompanyPortfolioChart } from './byCompanyPortfolioChart'
import { byCompanyTable } from './byCompanyTable'
import { byCountryPortfolioChart } from './byCountryPortfolioChart'
import { byCountryTable } from './byCountryTable'
import { portfolioCharts } from './portfolioCharts'
import { portfolioSettingDrawer } from './portfolioSettingDrawer'
import { modalToSelectFavoriteCompany } from './modalToSelectFavoriteCompany'
import { favoriteCompany } from './favoriteCompany'
import { searchTheme } from './searchTheme'
import { searchThemesFromCompanies } from './searchThemesFromCompanies'
import { modalToSearchThemeByCompany } from './modalToSearchThemeByCompany'
import { categoryList } from './categoryList'
import { clusterNameAnnotation } from './clusterNameAnnotation'
import { searchThemesFromTechnology } from './searchThemesFromTechnology'
import { searchThemesFromTrends } from './searchThemesFromTrends'
import { searchThemesFromTrendsCharts } from './searchThemesFromTrendsCharts'
import { searchThemesFromTrendsSettingDrawer } from './searchThemesFromTrendsSettingDrawer'
import { themeListOfTrends } from './themeListOfTrends'
import { timeSeriesOfPatentForTrends } from './timeSeriesOfPatentForTrends'
import { timeSeriesOfInvestmentAmountForTrends } from './timeSeriesOfInvestmentAmountForTrends'
import { userRegistrationPreCheck } from './userRegistrationPreCheck'
import { userRegistrationInputForm } from './userRegistrationInputForm'
import { userRegistrationComplete } from './userRegistrationComplete'

export const translation = {
    register,
    verify,
    common,
    home,
    companyProfile,
    cluster,
    clusterTable,
    clusterDetailTable,
    ipcTableOfClusterDetail,
    companyTableOfClusterDetail,
    patentTableOfClusterDetail,
    modalOfIpcTable,
    patentByYearChart,
    confirmationModalOfClusterValueChain,
    wordCloud,
    valueChain,
    network,
    chaosMap,
    clientManagement,
    signUpClient,
    systemInfoManagement,
    allServiceStop,
    simulation,
    loginiam,
    theme,
    chooseCmp,
    themePage,
    themePageCompanyAnaly,
    themePageCountryAnaly,
    aboutTheService,
    supportHeader,
    supportLink,
    howToUseModal,
    glossary,
    howToUse,
    newBusiness,
    strategyDevelopment,
    tooltip,
    allCompanyPortfolio,
    allCountryPortfolio,
    byCompanyPortfolioChart,
    byCompanyTable,
    byCountryPortfolioChart,
    byCountryTable,
    portfolioCharts,
    portfolioSettingDrawer,
    modalToSelectFavoriteCompany,
    favoriteCompany,
    searchTheme,
    searchThemesFromCompanies,
    modalToSearchThemeByCompany,
    categoryList,
    clusterNameAnnotation,
    searchThemesFromTechnology,
    searchThemesFromTrends,
    searchThemesFromTrendsCharts,
    searchThemesFromTrendsSettingDrawer,
    themeListOfTrends,
    timeSeriesOfPatentForTrends,
    timeSeriesOfInvestmentAmountForTrends,
    consultingAnalysis,
    userRegistrationPreCheck,
    userRegistrationInputForm,
    userRegistrationComplete
}
